import type { RGB } from './types';

const MAX_RGB_DISTANCE = 441;

export function removeColor(
  imageData: ImageData,
  sample: RGB,
  tolerance: number,
): ImageData {
  const clampedTolerance = Math.min(MAX_RGB_DISTANCE, Math.max(0, tolerance));
  const result = new ImageData(
    new Uint8ClampedArray(imageData.data),
    imageData.width,
    imageData.height,
  );

  for (let index = 0; index < result.data.length; index += 4) {
    const redDistance = result.data[index] - sample[0];
    const greenDistance = result.data[index + 1] - sample[1];
    const blueDistance = result.data[index + 2] - sample[2];
    const distance = Math.sqrt(
      redDistance ** 2 + greenDistance ** 2 + blueDistance ** 2,
    );

    if (distance <= clampedTolerance) result.data[index + 3] = 0;
  }

  return result;
}
